import { useCallback, useMemo, useState } from "react";

import { FlowVersion, FlowVersionFlowChild } from "src/api/flowTypes";
import { VersionManageModals } from "src/flow/types";
import { UnpublishedTemplateDependency } from "src/flow/usePublishFlowVersionCallback";

export type BuildOpenModalActionFn = (
  modal: VersionManageModals,
  version?: FlowVersion | undefined,
  unpublishedTemplates?: UnpublishedTemplateDependency[] | undefined,
) => () => void;

export const useFlowVersionModals = () => {
  const [currentModal, setCurrentModal] = useState<VersionManageModals>();
  const [selectedVersion, setSelectedVersion] = useState<FlowVersion>();
  const [unpublishedTemplates, setUnpublishedTemplates] =
    useState<UnpublishedTemplateDependency[]>();

  const buildOpenModalAction: BuildOpenModalActionFn = useCallback(
    (modal, version, unpublishedTemplates) => {
      return () => {
        setSelectedVersion(version);
        setUnpublishedTemplates(unpublishedTemplates);
        setCurrentModal(modal);
      };
    },
    [],
  );

  return useMemo(
    () => ({
      currentModal,
      selectedVersion,
      unpublishedTemplates,
      buildOpenModalAction,
      onOpenManageTrafficModal: buildOpenModalAction(
        "manage_traffic",
        selectedVersion,
      ),
      onAfterLeave: () => {
        setSelectedVersion(undefined);
        setUnpublishedTemplates(undefined);
      },
      onClose: () => {
        setCurrentModal(undefined);
      },
    }),
    [
      currentModal,
      selectedVersion,
      unpublishedTemplates,
      buildOpenModalAction,
      setSelectedVersion,
      setCurrentModal,
    ],
  );
};

export const useArchiveAction = (
  buildOpenModalAction: BuildOpenModalActionFn,
) => {
  const getArchiveAction = useCallback(
    (version: FlowVersionFlowChild) =>
      buildOpenModalAction("archive_version", version),
    [buildOpenModalAction],
  );

  return { getArchiveAction };
};
